import styled from 'styled-components';
export const LandingMaxContentWrapper = styled.div `
  width: 100%;
  margin: 0 auto;
  max-width: 130.4rem;
  padding: 0 2.2rem;
`;
//# sourceMappingURL=LandingMaxContentWrapper.js.map